import { generateSavedViewTarget } from "components/saved_searches/utils";
import { useSavedViews } from "lib/hooks/api/saved_views/useSavedViews";
import { routes } from "lib/routes";
import { SavedViewDataType } from "lib/types/graphQLEnums";

export enum StandardViewName {
  Competitor = "Competitor activity",
  Partner = "Partner activity",
  Expiries = "Upcoming contract expiries",
  CompetitorPartner = "Competitor & partner activity",
  Open = "Open & upcoming tenders",
}

export type UseStandardViewTargetOptions = {
  enabled?: boolean;
};

export function useStandardViewTarget(
  viewName: StandardViewName,
  options?: UseStandardViewTargetOptions,
) {
  const enabled = options?.enabled ?? true;
  const { data: standardViews, isLoading } = useSavedViews(
    { dataTypes: [SavedViewDataType.Notice], isStandardView: true },
    { page: 1, pageSize: 10 },
    { enabled },
  );

  const standardView = standardViews?.results.find((v) => v.name === viewName);

  const target: { to: string; search?: Record<string, unknown> } = standardView
    ? generateSavedViewTarget(standardView.id, SavedViewDataType.Notice)
    : { to: routes.notices };

  return { target, isLoading };
}
